import messages from '../messages';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  Banner,
  RadioGroup,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  SettingsIcon,
  AlertCriticalIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import React, { useEffect, useState } from 'react';
import useIntl from '../../../hooks/useIntl';

const ProposedChanges = (props) => {
  const {
    open,
    closeModal,
    onSubmit,
    isSubmitting,
    selectedProposedChangeType,
    disableChange,
  } = props;
  const [localProposedChangeType, setLocalProposedChangeType] = useState(
    selectedProposedChangeType,
  );
  const intl = useIntl();
  const options = [
    {
      label: 'Dollar Amount (e.g., $10.00)',
      value: 'dollar',
    },
    {
      label: 'Percentage (e.g., 10%)',
      value: 'percent',
    },
  ];

  useEffect(() => {
    setLocalProposedChangeType(selectedProposedChangeType);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={closeModal}
      title={intl.formatMessage(messages.proposedChanges)}
      icon={<SettingsIcon />}
      actionsProps={[
        {
          children: 'Cancel',
          onClick: closeModal,
        },
        {
          children: 'Confirm & Save',
          submitButton: true,
          isSubmitting,
          onClick: () => onSubmit(localProposedChangeType),
          disabled: disableChange,
        },
      ]}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 480,
            },
            maxHeight: 'calc(100vh - 100px)',
          },
        },
      }}
    >
      <>
        <Typography mb={2} variant="bodyMedium" display="block">
          {intl.formatMessage(messages.proposedChangesModalBody)}
        </Typography>
        <RadioGroup
          value={localProposedChangeType}
          items={options}
          onChange={(e) => setLocalProposedChangeType(e.target.value)}
          disabled={disableChange}
        />
        <Banner
          color="warning"
          icon={<AlertCriticalIcon />}
          text={intl.formatMessage(messages.proposedChangesModalWarning)}
          hasBorder={false}
          TypographyProps={{
            sx: {
              whiteSpace: 'normal',
            },
          }}
        />
      </>
    </Modal>
  );
};

export default ProposedChanges;
